import { t } from '@/i18n/utils'

export const loginCommonConfig = {
  texts: {
    get signInWithFacebook() { return t('Facebook') },
    get signInWithGoogle() { return t('Google') },
    get signInWithApple() { return t('Apple') },
    get continueWithEmail() { return t('ContinueWithEmail') },
    get signInWithEmail() { return t('EmailTitle') },
    get yourEmail() { return t('Email') },
    get verificationCode() { return t('VerificationCode') },
    get getVerificationCode() { return t('getVerificationCode') },
    get signIn() { return t('signIn') },
    get userAgreement() { return t('UserAgreement2') },
    get userAgreementLink() { return t('userAgreementLink') },
    get and() { return t('and') },
    get privacyPolicyLink() { return t('PrivacyPolicy') },
    get logout() { return t('logout') },
    get loading() { return t('loading') },
  },
}
